import { ThankYouPageWithConfig } from "@/components/ThankYouPage";
import type { SubmissionSuccessResponse } from "@/types/Payment";

export type FormStepSuccessProps = {
  submissionResponse: SubmissionSuccessResponse | null;
};

export function FormStepSuccess(props: FormStepSuccessProps) {
  const { submissionResponse } = props;

  if (!submissionResponse) return null;

  return (
    <ThankYouPageWithConfig
      donationReference={submissionResponse.donation_reference}
      enableFrontline={submissionResponse.missing_components.signup_frontline}
      enableGiftAid={submissionResponse.missing_components.gift_aid}
      submissionId={submissionResponse.submission.id}
      missingComponentsToken={submissionResponse.missing_components_token}
      amount={submissionResponse.amount}
      amountGift={submissionResponse.amount_gift || 0}
    />
  );
}
